const gatewayTypes = {
    GATEWAY_TYPE_BANK_CARD: 'bankcard',
    GATEWAY_TYPE_SEPA: 'sepa',
    GATEWAY_TYPE_PAYPAL: 'paypal',
};

export default gatewayTypes;
